export default "__VITE_ASSET__c9892930__"